<template>
    <div>
        <el-form
            style="background: #fff; padding: 20px"
            class="topForm"
            ref="form"
            :model="form"
            status-icon
            :rules="rules"
            label-width="100px"
        >
            <el-container style="background: #fff; border-radius: 15px; padding-top: 20px; padding-right: 20px; margin-bottom: 10px">
                <el-main style="padding: 0 20px 0 0">
                    <el-col :span="8" :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                        <el-form-item label="开始日期" prop="begin_date">
                            <el-date-picker
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                v-model="form.begin_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                        <el-form-item label="结束日期" prop="end_date">
                            <el-date-picker
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                v-model="form.end_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                        <el-form-item label="银行">
                            <label slot="label">银&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;行</label>
                            <el-select
                                v-model="form.bank_no"
                                clearable
                                @visible-change="myClear"
                                filterable
                                :filter-method="searchBnk"
                                @change="refreshs()"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="(item, index) in pull_bank"
                                    :key="index"
                                    :label="item.kind_name"
                                    :value="item.kind_no.toString()"
                                >
                                    <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                    <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-button type="primary" @click="selectTable('form')">{{ $t('common.confirm') }}</el-button>
                    <el-button type="primary" @click="printContext" v-if="perData.allow_print == 1">{{ $t('common.print') }}</el-button>
                    <el-button style="margin-right: 10px" type="primary" @click="toImg" v-if="perData.allow_print == 1"
                        >转图片下载</el-button
                    >
                </el-main>
            </el-container>
            <!-- <el-button @click="download">下载</el-button> -->
            <div class="totaltable" style="margin-top: 30px; clear: both" v-if="dtlArr != ''">
                <div id="print" ref="print" style="width: 100%; text-align: center; page-break-after: always">
                    <p class="company" v-if="systemSet.company">{{ systemSet.company }}</p>
                    <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px">现金银行账明细表</div>
                    <table border="1" cellpadding="0" cellspacing="0">
                        <tr align="center">
                            <th>业务单号</th>
                            <th>时间</th>
                            <th>客户</th>
                            <th>银行</th>
                            <th>货币</th>
                            <th>收入</th>
                            <th>支出</th>
                            <th>备注</th>
                        </tr>
                        <tr
                            align="center"
                            v-for="(item, index) in dtlArr"
                            :key="index"
                            :style="item.type == '合计' ? 'color:red;font-weight:bold;' : ''"
                        >
                            <td>{{ item.bill_no }}</td>
                            <td>{{ item.bill_date }}</td>
                            <td>{{ item.cust_name }}</td>
                            <td>{{ item.bank_name }}</td>
                            <td>{{ item.currency_name }}</td>
                            <td>{{ item.income }}</td>
                            <td>{{ item.pay }}</td>
                            <td>{{ item.remark }}</td>
                        </tr>
                    </table>

                    <big-name></big-name>
                </div>
            </div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-size="pageSize"
                    :page-sizes="[30, 40, 50]"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
            <!-- <img :src="img" alt=""> -->
        </el-form>
    </div>
</template>

<script>
import { apiMoneyBank, apiMoneyBankPull, apiCurrentPermisson, apiSystem } from '@/request/api';
import print from 'print-js';
import html2canvas from 'html2canvas';
export default {
    name: 'moneyBank',
    data() {
        return {
            form: { begin_date: '', end_date: '' },
            pull_bank: [],
            rules: {
                begin_date: [{ required: true, message: '请选择起始日期', trigger: 'change' }],
                end_date: [{ required: true, message: '请选择结束日期', trigger: 'change' }]
            },
            kindArr: [],
            kindTotal: '',
            kindData: '',
            counterList: [],
            dtlArr: [],
            allArr: '',
            outData: { isshow: false, scope: null, index: 0, data: {} },
            salesman_no: '',
            cust_type: '',
            bank_no: '',
            pageIndex: 1,
            pageSize: 30,
            pageTotal: 0,
            img: '',
            perData: '',
            systemSet: ''
        };
    },
    watch: {},
    created() {
        // this.selectTable();
        this.getPull();
        this.getPermission();
        this.getSystem();
        var d = new Date();
        var a = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        this.form.begin_date = a;
        this.form.end_date = a;
    },
    methods: {
        getPull() {
            apiMoneyBankPull({}).then(res => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_bank = res.data.bank;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        selectTable(formName) {
            this.$load.show();
            this.pageIndex = 1;
            this.dtlArr = [];
            this.pageTotal = 0;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    apiMoneyBank({
                        page: this.pageIndex,
                        page_size: this.pageSize,
                        bank_no: this.form.bank_no,
                        begin_date: this.form.begin_date,
                        end_date: this.form.end_date
                    }).then(res => {
                        this.$load.close();
                        if (res.code == 2000) {
                            // router.afterEach(() => {
                            //     // 在即将进入新的页面组件前，关闭掉进度条
                            //     NProgress.done()
                            // })
                            this.dtlArr = res.data.data;
                            this.pageTotal = res.data.count;
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        getData() {
            apiMoneyBank({
                page: this.pageIndex,
                page_size: this.pageSize,
                bank_no: this.form.bank_no,
                begin_date: this.form.begin_date,
                end_date: this.form.end_date
            }).then(res => {
                if (res.code == 2000) {
                    // router.afterEach(() => {
                    //     // 在即将进入新的页面组件前，关闭掉进度条
                    //     NProgress.done()
                    // })
                    this.dtlArr = res.data.data;
                    this.pageTotal = res.data.count;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        toImg() {
            html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then(canvas => {
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
                // printJS({
                //     printable: url,
                //     type: 'image',
                //     documentTitle: '打印图片'
                // })
            });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile('现金银行帐明细表.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            //aLink.click()
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '65'
            }).then(res => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then(res => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 下拉框出现和隐藏时
        myClear() {
            this.pull_cust = this.allArr.cust;
        },
        searchBnk(val) {
            this.form.bank_no = val;
            if (val) {
                var len = this.allArr.bank;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].kind_name.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_bank = arr;
            } else {
                this.pull_bank = this.allArr.bank;
            }
        },
        refreshs() {
            this.$forceUpdate();
        }
    }
};
</script>

<style scoped>
.totaltable table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}
.totaltable table td,
.totaltable table th {
    border: 1px solid #000;
    padding: 5px 0;
}
.totaltable table th {
    font-weight: bold;
    color: #000;
}
.totaltable table tr:nth-child(even) {
    background: #e9ebed;
}
.company {
    text-align: center;
    font-size: 16px;
    color: rgb(7, 16, 114);
    font-weight: bold;
    letter-spacing: 5px;
}
.custtable .el-select {
    width: 80%;
    margin-top: 10px;
}
@media screen and (max-width: 768px) {
    .totaltable table td,
    .totaltable table th {
        font-size: 12px;
    }
    .raio {
        margin-top: 10px;
    }
    .el-pagination {
        white-space: inherit;
    }
}
@media print {
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }
}
</style>
